"use client";
import React from "react";
import "./Common.css";
import ButtonAnimated from "@/components/ButtonAnimated/ButtonAnimated";

function StickyWidget() {
  return (
    <div className="StickyWidget">
      <div className="Widget">
        <h3>Verkaufe dein Auto auf die Autoeinfachlos-Art</h3>

        <ButtonAnimated
          link={"/"}
          text="Jetzte Auto Bewerten"
          height="48px"
          fontSize="18px"
          hideChevron={true}
          width="100%"
          className="StickyWidgetButton"
          tooltipOffset="-120%"
        />
      </div>
    </div>
  );
}

export default StickyWidget;
